import * as L from "leaflet";

/**
 * Explanation of the formula: https://wiki.openstreetmap.org/wiki/Zoom_levels
 * */
export const calculateMetersPerPixelForZoomLevel = (map: L.Map, zoomLevel = map.getZoom()) => {
  const earthCircumferenceInMeters = 40075016.686;
  const latitudeRadians = (map.getCenter().lat * Math.PI) / 180;

  return (
    (earthCircumferenceInMeters * Math.abs(Math.cos(latitudeRadians))) / Math.pow(2, zoomLevel + 8)
  );
};

/**
 * Calculates meters per pixel for all zoom levels in the map.
 * Explanation of the formula: https://wiki.openstreetmap.org/wiki/Zoom_levels
 * */
export const calculateMetersPerPixelForZoomLevels = (map: L.Map) => {
  const minZoom = map.getMinZoom();
  const maxZoom = map.getMaxZoom();

  const metersInPixelsForZoomLevels: Record<number, number> = {};

  for (let zoom = minZoom; zoom <= maxZoom; zoom++) {
    metersInPixelsForZoomLevels[zoom] = calculateMetersPerPixelForZoomLevel(map, zoom);
  }

  return metersInPixelsForZoomLevels;
};
